export const DEPARTAMENTOS = [
  'Artigas', 'Canelones', 'Cerro Largo', 'Colonia', 'Durazno',
  'Flores', 'Florida', 'Lavalleja', 'Maldonado', 'Montevideo',
  'Paysandú', 'Río Negro', 'Rivera', 'Rocha', 'Salto',
  'San José', 'Soriano', 'Tacuarembó', 'Treinta y Tres'
];

// Código postal → { localidad, departamento, ciudad }
export const CODIGOS_POSTALES = {
  // Montevideo
  '11000': { localidad: 'Ciudad Vieja', ciudad: 'Montevideo', departamento: 'Montevideo' },
  '11100': { localidad: 'Centro', ciudad: 'Montevideo', departamento: 'Montevideo' },
  '11200': { localidad: 'Cordón', ciudad: 'Montevideo', departamento: 'Montevideo' },
  '11300': { localidad: 'Palermo', ciudad: 'Montevideo', departamento: 'Montevideo' },
  '11400': { localidad: 'Pocitos', ciudad: 'Montevideo', departamento: 'Montevideo' },
  '11500': { localidad: 'Punta Carretas', ciudad: 'Montevideo', departamento: 'Montevideo' },
  '11600': { localidad: 'Buceo', ciudad: 'Montevideo', departamento: 'Montevideo' },
  '11700': { localidad: 'Malvín', ciudad: 'Montevideo', departamento: 'Montevideo' },
  '11800': { localidad: 'Unión', ciudad: 'Montevideo', departamento: 'Montevideo' },
  '11900': { localidad: 'Carrasco', ciudad: 'Montevideo', departamento: 'Montevideo' },
  '12000': { localidad: 'Parque Batlle', ciudad: 'Montevideo', departamento: 'Montevideo' },
  '12100': { localidad: 'Tres Cruces', ciudad: 'Montevideo', departamento: 'Montevideo' },
  '12200': { localidad: 'Brazo Oriental', ciudad: 'Montevideo', departamento: 'Montevideo' },
  '12300': { localidad: 'Prado', ciudad: 'Montevideo', departamento: 'Montevideo' },
  '12400': { localidad: 'Peñarol', ciudad: 'Montevideo', departamento: 'Montevideo' },
  '12500': { localidad: 'Cerrito', ciudad: 'Montevideo', departamento: 'Montevideo' },
  '13000': { localidad: 'Aguada', ciudad: 'Montevideo', departamento: 'Montevideo' },
  // Maldonado / Punta del Este
  '20000': { localidad: 'Maldonado', ciudad: 'Maldonado', departamento: 'Maldonado' },
  '20100': { localidad: 'Punta del Este', ciudad: 'Punta del Este', departamento: 'Maldonado' },
  '20200': { localidad: 'San Carlos', ciudad: 'San Carlos', departamento: 'Maldonado' },
  '20300': { localidad: 'Piriápolis', ciudad: 'Piriápolis', departamento: 'Maldonado' },
  '20400': { localidad: 'Pan de Azúcar', ciudad: 'Pan de Azúcar', departamento: 'Maldonado' },
  '20500': { localidad: 'Aiguá', ciudad: 'Aiguá', departamento: 'Maldonado' },
  '20600': { localidad: 'José Ignacio', ciudad: 'José Ignacio', departamento: 'Maldonado' },
  '20700': { localidad: 'La Barra', ciudad: 'La Barra', departamento: 'Maldonado' },
  '20800': { localidad: 'Manantiales', ciudad: 'Manantiales', departamento: 'Maldonado' },
  // Canelones
  '15000': { localidad: 'Canelones', ciudad: 'Canelones', departamento: 'Canelones' },
  '15100': { localidad: 'Las Piedras', ciudad: 'Las Piedras', departamento: 'Canelones' },
  '15200': { localidad: 'Pando', ciudad: 'Pando', departamento: 'Canelones' },
  '15300': { localidad: 'Ciudad de la Costa', ciudad: 'Ciudad de la Costa', departamento: 'Canelones' },
  '15400': { localidad: 'La Paz', ciudad: 'La Paz', departamento: 'Canelones' },
  '15500': { localidad: 'Atlántida', ciudad: 'Atlántida', departamento: 'Canelones' },
  '15600': { localidad: 'Salinas', ciudad: 'Salinas', departamento: 'Canelones' },
  // Colonia
  '70000': { localidad: 'Colonia del Sacramento', ciudad: 'Colonia del Sacramento', departamento: 'Colonia' },
  '70100': { localidad: 'Carmelo', ciudad: 'Carmelo', departamento: 'Colonia' },
  '70200': { localidad: 'Nueva Helvecia', ciudad: 'Nueva Helvecia', departamento: 'Colonia' },
  // Salto
  '50000': { localidad: 'Salto', ciudad: 'Salto', departamento: 'Salto' },
  // Paysandú
  '60000': { localidad: 'Paysandú', ciudad: 'Paysandú', departamento: 'Paysandú' },
  // Rivera
  '40000': { localidad: 'Rivera', ciudad: 'Rivera', departamento: 'Rivera' },
  // Rocha
  '27000': { localidad: 'Rocha', ciudad: 'Rocha', departamento: 'Rocha' },
  '27100': { localidad: 'La Paloma', ciudad: 'La Paloma', departamento: 'Rocha' },
  '27200': { localidad: 'Chuy', ciudad: 'Chuy', departamento: 'Rocha' },
  // San José
  '80000': { localidad: 'San José de Mayo', ciudad: 'San José de Mayo', departamento: 'San José' },
  // Tacuarembó
  '45000': { localidad: 'Tacuarembó', ciudad: 'Tacuarembó', departamento: 'Tacuarembó' },
  // Florida
  '94000': { localidad: 'Florida', ciudad: 'Florida', departamento: 'Florida' },
  // Durazno
  '97000': { localidad: 'Durazno', ciudad: 'Durazno', departamento: 'Durazno' },
  // Artigas
  '55000': { localidad: 'Artigas', ciudad: 'Artigas', departamento: 'Artigas' },
};

// Localidades por departamento para sugerencias
export const LOCALIDADES_POR_DEPTO = {
  'Maldonado': ['Punta del Este', 'Maldonado', 'San Carlos', 'Piriápolis', 'Pan de Azúcar', 'José Ignacio', 'La Barra', 'Manantiales', 'Aiguá', 'Garzón'],
  'Montevideo': ['Ciudad Vieja', 'Centro', 'Cordón', 'Pocitos', 'Punta Carretas', 'Buceo', 'Malvín', 'Carrasco', 'Prado', 'Parque Batlle', 'Aguada', 'Palermo', 'Unión', 'Tres Cruces'],
  'Canelones': ['Las Piedras', 'Pando', 'Ciudad de la Costa', 'La Paz', 'Atlántida', 'Salinas', 'Canelones', 'Santa Lucía'],
  'Colonia': ['Colonia del Sacramento', 'Carmelo', 'Nueva Helvecia', 'Juan Lacaze'],
  'Salto': ['Salto', 'Constitución'],
  'Paysandú': ['Paysandú', 'Guichón'],
  'Rivera': ['Rivera', 'Tranqueras'],
  'Rocha': ['Rocha', 'La Paloma', 'Chuy', 'Lascano', 'Castillos'],
  'San José': ['San José de Mayo', 'Libertad', 'Ecilda Paullier'],
  'Tacuarembó': ['Tacuarembó', 'Paso de los Toros'],
  'Florida': ['Florida', 'Sarandí Grande'],
  'Durazno': ['Durazno', 'Sarandí del Yí'],
  'Artigas': ['Artigas', 'Bella Unión'],
  'Cerro Largo': ['Melo', 'Río Branco'],
  'Lavalleja': ['Minas', 'José Batlle y Ordóñez'],
  'Flores': ['Trinidad'],
  'Río Negro': ['Fray Bentos', 'Young'],
  'Soriano': ['Mercedes', 'Dolores'],
  'Treinta y Tres': ['Treinta y Tres', 'Vergara'],
};
